
import { mapState } from 'vuex';

export default {
    name: 'GroupHeader',
    props: {
        /**
         * The group object
         */
        group: {
            type: Object,
            required: true,
        },
        /**
         * Are we a member?
         */
        isMember: {
            type: Boolean,
            required: true,
        },
        /**
         * Is the current user subscribed
         */
        isSubscribed: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            subscribed: this.isSubscribed,
        };
    },
    computed: {
        ...mapState(['auth']),
        isOwner() {
            if (!this.auth.loggedIn) {
                return false;
            }
            return this.group.user_id === this.auth.user.id || this.auth.user.role === 'admin';
        },
    },
    methods: {
        confirmDelete() {
            this.$store.dispatch('showConfirm', {
                callback: this.deleteGroup,
                text: this.$t('groups.confirm_delete'),
            });
        },
        async deleteGroup() {
            const { message } = await this.$axios.$delete(`${this.$config.endpoints.group}/${this.$route.params.slug}`);
            this.$store.dispatch('setFlashMessage', { message });
            this.$router.push({ name: 'groups' });
        },
        async joinGroup() {
            const { message } = await this.$axios.$put(`${this.$config.endpoints.group}/${this.$route.params.slug}/join`);
            /**
             * Join group
             *
             * @type {object}
             */
            this.$emit('update-membership', true);
            this.$store.dispatch('setFlashMessage', { message });
        },
        async leaveGroup() {
            const { message } = await this.$axios.$put(`${this.$config.endpoints.group}/${this.$route.params.slug}/leave`, {
                user: this.$store.state.auth.user,
            });
            /**
             * Leave group
             *
             * @type {object}
             */
            this.$emit('update-membership', false);
            this.$store.dispatch('setFlashMessage', { message });
        },
        async subscribe() {
            const endpoint = this.subscribed ? 'unsubscribe' : 'subscribe';
            const { message } = await this.$axios.$post(`${this.$config.endpoints.group}/${this.$route.params.slug}/${endpoint}`);
            this.subscribed = !this.subscribed;
            this.$store.dispatch('setFlashMessage', { message });
        },
    },
};
